export default "__VITE_ASSET__96d14a97__"